/* eslint-disable import/order */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 as uuidV4 } from 'uuid';
import fixWebmDuration from 'webm-duration-fix';
import * as Sentry from '@sentry/react';
// @ts-ignore
import { setRequestingSubtitles } from '../../../subtitles/';
// @ts-ignore
import { getRoomName, getEventId, getTranscriptData, getDefaultTranscriptEnabled } from '../../../base/conference';
// @ts-ignore
import { disconnect } from '../../../base/connection';
// @ts-ignore
import { MEDIA_TYPE, setVideoMuted } from '../../../base/media';
// @ts-ignore
import { showErrorNotification } from '../../../notifications';
// @ts-ignore
import { getTrackState, getLocalTrack } from '../../../base/tracks';
import { inIframe } from '../../../base/util/iframeUtils';
// @ts-ignore
import { stopLocalVideoRecording } from '../../actions.any';
// @ts-ignore
import { setTacniqueTestLocalRecordingOn } from '../../../prejoin/actions.js';
import axios from 'axios';
const getMimeType = () => {
    const possibleTypes = [
        'video/mp4;codecs=h264',
        'video/webm;codecs=h264',
        'video/webm;codecs=vp9',
        'video/webm;codecs=vp8'
    ];
    for (const type of possibleTypes) {
        if (MediaRecorder.isTypeSupported(type)) {
            return type;
        }
    }
    throw new Error('No MIME Type supported by MediaRecorder');
};
const VIDEO_BIT_RATE = 2500000; // 2.5Mbps in bits
// Lazily initialize.
let preferredMediaType;
const LocalRecordingManager = {
    recordingData: [],
    testRecordingData: [],
    transcriptData: [],
    enabled: false,
    transcriptBlob: [],
    recorder: undefined,
    stream: undefined,
    audioContext: undefined,
    audioDestination: undefined,
    hasUploaded: false,
    isRecordingPause: false,
    roomName: '',
    eventId: 0,
    startRecodingTime: '',
    isVideoTrackError: false,
    totalSize: 1288490188.8,
    totalTestSize: 2097152,
    selfRecording: {
        on: false,
        withVideo: false
    },
    get mediaType() {
        if (!preferredMediaType) {
            preferredMediaType = getMimeType();
        }
        return preferredMediaType;
    },
    /**
   * Initializes audio context used for mixing audio tracks.
   *
   * @returns {void}
   */
    initializeAudioMixer() {
        this.audioContext = new AudioContext();
        this.audioDestination = this.audioContext.createMediaStreamDestination();
    },
    /**
   * Mixes multiple audio tracks to the destination media stream.
   *
   * @param {MediaStream} stream - The stream to mix.
   * @returns {void}
   * */
    mixAudioStream(stream) {
        var _a;
        if (stream.getAudioTracks().length > 0 && this.audioDestination) {
            (_a = this.audioContext) === null || _a === void 0 ? void 0 : _a.createMediaStreamSource(stream).connect(this.audioDestination);
        }
    },
    /**
   * Adds audio track to the recording stream.
   *
   * @param {MediaStreamTrack} track - The track to be added.
   * @returns {void}
   */
    addAudioTrackToLocalRecording(track) {
        if (this.selfRecording.on) {
            return;
        }
        if (track) {
            const stream = new MediaStream([track]);
            this.mixAudioStream(stream);
        }
    },
    /**
   * Returns a filename based ono the Jitsi room name in the URL and timestamp.
   *
   * @returns {string}
   * */
    getFilename() {
        const now = new Date();
        const timestamp = now.toISOString();
        return `${this.roomName}_${timestamp}`;
    },
    /**
   * Saves local recording to file.
   *
   * @param {Array} recordingData - The recording data.
   * @param {string} filename - The name of the file.
   * @returns {void}
   * */
    saveRecording(recordingData, filename) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            const blob = yield fixWebmDuration(new Blob(recordingData, { type: this.mediaType }));
            // @ts-ignore
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            const extension = this.mediaType.slice(this.mediaType.indexOf('/') + 1, this.mediaType.indexOf(';'));
            const fileName = filename.slice(filename.indexOf(''), filename.indexOf('.'));
            a.style.display = 'none';
            a.href = url;
            a.download = `${filename}.${extension}`;
            a.click();
            const file = new File([blob], fileName, { type: this.mediaType });
            const formData = new FormData();
            if (this.enabled) {
                this.saveTranscript();
                const transcriptFile = new File(this.transcriptBlob, `transcript_${fileName}.txt`, { type: 'text/plain' });
                formData.append('transcript', transcriptFile);
            }
            formData.append('context_id', this.eventId.toString());
            formData.append('title', fileName);
            formData.append('mimetype', this.mediaType);
            formData.append('file', file);
            formData.append('recording_started_at', this.startRecodingTime);
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            this.uploadLocalRecording(formData, 1);
            this.recordingData = [];
        });
    },
    saveTranscript() {
        // transcript file
        // @ts-ignore
        const blob = new Blob(this.transcriptData, { type: 'text/plain' });
        // @ts-ignore
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `transcript_${this.roomName}.txt`;
        a.click();
        this.transcriptBlob.push(blob);
    },
    saveTestRecording() {
        // @ts-ignore
        const blob = new Blob(this.testRecordingData, { type: this.mediaType });
        // @ts-ignore
        const url = window.URL.createObjectURL(blob);
        const aTag = document.createElement('a');
        aTag.style.display = 'none';
        aTag.href = url;
        aTag.download = `test_${this.roomName}.webm`;
        aTag.click();
        this.testRecordingData = [];
    },
    stopTestLocalRecording() {
        if (this.recorder) {
            this.recorder.stop();
            this.recorder = undefined;
            this.audioContext = undefined;
            this.audioDestination = undefined;
            this.isRecordingPause = false;
            this.saveTestRecording();
            APP.store.dispatch(setTacniqueTestLocalRecordingOn(false));
        }
    },
    /**
   * Stops local recording.
   *
   * @returns {void}
   * */
    stopLocalRecording() {
        if (this.recorder) {
            this.recorder.stop();
            this.recorder = undefined;
            this.audioContext = undefined;
            this.audioDestination = undefined;
            this.isRecordingPause = false;
            setTimeout(() => this.saveRecording(this.recordingData, this.getFilename()), 1000);
            APP.store.dispatch(setVideoMuted(true));
            // APP.store.dispatch(setAudioMuted(true));
        }
        const modal = document.createElement('div');
        modal.setAttribute('id', 'recordingProgress');
        modal.setAttribute('class', 'recording-modal');
        modal.innerHTML = `<div class="container">
            <div class="dialog">
            <div class="modal-content">
                <div class="header">
                    <p>Upload meeting recording</p>
                </div>
                <div class="section">
                    <p>The meeting recording is being uploaded. Please do not refresh or close the tab till it is complete.</p>
                    <div
                        className = 'progress-indicator'
                        id = 'recordingProgressBar'>
                        <div
                        class= 'progress-indicator-fill'
                        style='width:0%'/>
                        </div>
                    </div>
                </div>
            </div>
            </div>`;
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(modal);
    },
    uploadLocalRecording(formData, retryApi = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            const self = this;
            const requestConfig = {
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    const progressBar = document.querySelector('.progress-indicator-fill');
                    console.log('Percent: ', percentCompleted);
                    progressBar.style.width = `${percentCompleted}%`;
                    progressBar.innerHTML = `${percentCompleted}%`;
                    // eslint-disable-next-line max-len
                    const successDisplayMessage = `https://${config.hosts.domain}?message_type=success&message_body=Upload was successful, please remember to include skill recommendations to obtain video recording.`;
                    // eslint-disable-next-line max-len
                    const errorDisplayMessage = `https://${config.hosts.domain}?message_type=error&message_body=The upload was not successful, so kindly proceed with manual uploading.`;
                    if (percentCompleted === 100) {
                        // @ts-ignore
                        self.hasUploaded = true;
                        const modal = document.getElementById('recordingProgress');
                        modal.style.display = 'none';
                        setTimeout(() => {
                            APP.store.dispatch(disconnect(true));
                            // @ts-ignore
                            window.location.href = formData.get('file') === null ? errorDisplayMessage : successDisplayMessage;
                        }, 10000);
                    }
                }
            };
            yield axios
                .post(`${config.hosts.api_url}/rooms/events/attachments/`, formData, requestConfig)
                .then((res) => {
                console.log(res, 'uploaded');
                if (res.status === 201) {
                    this.hasUploaded = true;
                }
            })
                .catch((err) => {
                console.log('formData for Failed response:', formData);
                Sentry.captureException(err);
                if (retryApi > 0) {
                    console.log(`Retrying POST request, ${retryApi} retries left.`);
                    return this.uploadLocalRecording(formData, retryApi - 1);
                }
                console.error('Failed to POST data:', err);
                console.log(err);
            });
        });
    },
    //     /**
    //    * Stops local recording.
    //    *
    //    * @returns {void}
    //    * */
    //     pauseLocalRecording() {
    //         if (this.recorder) {
    //             this.recorder.pause();
    //             this.isRecordingPause = true;
    //         }
    //     },
    //     /**
    //    * Stops local recording.
    //    *
    //    * @returns {void}
    //    * */
    //     resumeLocalRecording() {
    //         if (this.recorder) {
    //             this.recorder.resume();
    //             this.isRecordingPause = false;
    //         }
    //     },
    /**
   * Stops local recording.
   *
   * @returns {void}
   * */
    pauseLocalRecording() {
        if (this.recorder) {
            this.recorder.pause();
            this.isRecordingPause = true;
        }
    },
    /**
   * Stops local recording.
   *
   * @returns {void}
   * */
    resumeLocalRecording() {
        if (this.recorder) {
            this.recorder.resume();
            this.isRecordingPause = false;
        }
    },
    /**
   * Starts a local recording.
   *
   * @param {IStore} store - The redux store.
   * @param {boolean} onlySelf - Whether to record only self streams.
   * @returns {void}
   */
    startLocalRecording(store, onlySelf) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __awaiter(this, void 0, void 0, function* () {
            const { dispatch, getState } = store;
            const dateObject = new Date();
            const currentDateTime = dateObject.toISOString();
            this.startRecodingTime = currentDateTime;
            // @ts-ignore
            const supportsCaptureHandle = Boolean(navigator.mediaDevices.setCaptureHandleConfig) && !inIframe();
            const tabId = uuidV4();
            this.selfRecording.on = onlySelf;
            this.recordingData = [];
            this.roomName = (_a = getRoomName(getState())) !== null && _a !== void 0 ? _a : '';
            this.eventId = getEventId(getState());
            this.transcriptData = getTranscriptData(getState());
            this.enabled = getDefaultTranscriptEnabled(getState());
            store.dispatch(setRequestingSubtitles(this.enabled));
            let gdmStream = new MediaStream();
            const tracks = getTrackState(getState());
            if (onlySelf) {
                let audioTrack = (_c = (_b = getLocalTrack(tracks, MEDIA_TYPE.AUDIO)) === null || _b === void 0 ? void 0 : _b.jitsiTrack) === null || _c === void 0 ? void 0 : _c.track;
                let videoTrack = (_e = (_d = getLocalTrack(tracks, MEDIA_TYPE.VIDEO)) === null || _d === void 0 ? void 0 : _d.jitsiTrack) === null || _e === void 0 ? void 0 : _e.track;
                if (!audioTrack) {
                    APP.conference.muteAudio(false);
                    setTimeout(() => APP.conference.muteAudio(true), 100);
                    yield new Promise(resolve => {
                        setTimeout(resolve, 100);
                    });
                }
                if (videoTrack && videoTrack.readyState !== 'live') {
                    videoTrack = undefined;
                }
                audioTrack = (_g = (_f = getLocalTrack(getTrackState(getState()), MEDIA_TYPE.AUDIO)) === null || _f === void 0 ? void 0 : _f.jitsiTrack) === null || _g === void 0 ? void 0 : _g.track;
                if (!audioTrack && !videoTrack) {
                    throw new Error('NoLocalStreams');
                }
                this.selfRecording.withVideo = Boolean(videoTrack);
                const localTracks = [];
                audioTrack && localTracks.push(audioTrack);
                videoTrack && localTracks.push(videoTrack);
                this.stream = new MediaStream(localTracks);
            }
            else {
                if (supportsCaptureHandle) {
                    // @ts-ignore
                    navigator.mediaDevices.setCaptureHandleConfig({
                        handle: `JitsiMeet-${tabId}`,
                        permittedOrigins: ['*']
                    });
                }
                const localAudioTrack = (_j = (_h = getLocalTrack(tracks, MEDIA_TYPE.AUDIO)) === null || _h === void 0 ? void 0 : _h.jitsiTrack) === null || _j === void 0 ? void 0 : _j.track;
                // Starting chrome 107, the recorder does not record any data if the audio stream has no tracks
                // To fix this we create a track for the local user(muted track)
                if (!localAudioTrack) {
                    APP.conference.muteAudio(false);
                    setTimeout(() => APP.conference.muteAudio(true), 100);
                    yield new Promise(resolve => {
                        setTimeout(resolve, 100);
                    });
                }
                // handle no mic permission
                if (!((_l = (_k = getLocalTrack(getTrackState(getState()), MEDIA_TYPE.AUDIO)) === null || _k === void 0 ? void 0 : _k.jitsiTrack) === null || _l === void 0 ? void 0 : _l.track)) {
                    throw new Error('NoMicTrack');
                }
                // @ts-ignore
                gdmStream = yield navigator.mediaDevices.getDisplayMedia({
                    // @ts-ignore
                    video: { displaySurface: 'browser',
                        frameRate: { ideal: 30, max: 30 } },
                    audio: false,
                    preferCurrentTab: true
                });
                Sentry.captureMessage('selected preffered tab');
                // @ts-ignore
                const isBrowser = gdmStream.getVideoTracks()[0].getSettings().displaySurface === 'browser';
                if (!isBrowser || (supportsCaptureHandle // @ts-ignore
                    && ((_m = gdmStream.getVideoTracks()[0].getCaptureHandle()) === null || _m === void 0 ? void 0 : _m.handle) !== `JitsiMeet-${tabId}`)) {
                    gdmStream.getTracks().forEach((track) => track.stop());
                    throw new Error('WrongSurfaceSelected');
                }
                this.initializeAudioMixer();
                const allTracks = getTrackState(getState());
                allTracks.forEach((track) => {
                    var _a;
                    if (track.mediaType === MEDIA_TYPE.AUDIO) {
                        const audioTrack = (_a = track === null || track === void 0 ? void 0 : track.jitsiTrack) === null || _a === void 0 ? void 0 : _a.track;
                        this.addAudioTrackToLocalRecording(audioTrack);
                    }
                });
                this.stream = new MediaStream([
                    ...((_o = this.audioDestination) === null || _o === void 0 ? void 0 : _o.stream.getAudioTracks()) || [],
                    gdmStream.getVideoTracks()[0]
                ]);
            }
            this.recorder = new MediaRecorder(this.stream, {
                mimeType: this.mediaType,
                videoBitsPerSecond: VIDEO_BIT_RATE
            });
            Sentry.captureMessage('recorder initialized and recording started');
            this.recorder.addEventListener('dataavailable', e => {
                if (e.data && e.data.size > 0) {
                    if (e.data.type.startsWith('audio') && this.isVideoTrackError === false) {
                        Sentry.captureMessage('screen recording missing started');
                        console.log('isVideoTrackError', this.isVideoTrackError);
                        this.isVideoTrackError = true;
                        dispatch(showErrorNotification({
                            titleKey: 'Missing Recording Data',
                            custom: true,
                            // eslint-disable-next-line max-len
                            description: 'Please be advised that there is a possibility of audio or video missing from the recording. It is recommended to restart the browser and rejoin the meeting'
                        }));
                    }
                    this.recordingData.push(e.data);
                    this.totalSize -= e.data.size;
                    if (this.totalSize <= 0) {
                        this.stopLocalRecording();
                    }
                }
            });
            this.recorder.addEventListener('error', event => {
                Sentry.captureMessage('Error occurred in recorder, captured in Event Listener');
                dispatch(showErrorNotification({
                    titleKey: 'Error occurred while recording',
                    custom: true,
                    //  @ts-ignore
                    description: event.error.name
                }));
            });
            if (!onlySelf) {
                this.recorder.addEventListener('stop', () => {
                    var _a;
                    (_a = this.stream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach((track) => track.stop());
                    gdmStream === null || gdmStream === void 0 ? void 0 : gdmStream.getTracks().forEach((track) => track.stop());
                });
                gdmStream === null || gdmStream === void 0 ? void 0 : gdmStream.addEventListener('inactive', () => {
                    dispatch(stopLocalVideoRecording());
                });
                this.stream.addEventListener('inactive', () => {
                    dispatch(stopLocalVideoRecording());
                });
            }
            this.recorder.start(5000);
            this.hasUploaded = false;
        });
    },
    /**
   * Starts a local recording.
   *
   * @param {IStore} store - The redux store.
   * @param {boolean} onlySelf - Whether to record only self streams.
   * @returns {void}
   */
    startTestLocalRecording(store, onlySelf) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function* () {
            const { dispatch, getState } = store;
            const dateObject = new Date();
            const currentDateTime = dateObject.toISOString();
            this.startRecodingTime = currentDateTime;
            // @ts-ignore
            const supportsCaptureHandle = Boolean(navigator.mediaDevices.setCaptureHandleConfig) && !inIframe();
            const tabId = uuidV4();
            this.selfRecording.on = onlySelf;
            this.testRecordingData = [];
            let gdmStream = new MediaStream();
            const tracks = getTrackState(getState());
            if (onlySelf) {
                let audioTrack = (_b = (_a = getLocalTrack(tracks, MEDIA_TYPE.AUDIO)) === null || _a === void 0 ? void 0 : _a.jitsiTrack) === null || _b === void 0 ? void 0 : _b.track;
                let videoTrack = (_d = (_c = getLocalTrack(tracks, MEDIA_TYPE.VIDEO)) === null || _c === void 0 ? void 0 : _c.jitsiTrack) === null || _d === void 0 ? void 0 : _d.track;
                if (!audioTrack) {
                    APP.conference.muteAudio(false);
                    setTimeout(() => APP.conference.muteAudio(true), 100);
                    yield new Promise(resolve => {
                        setTimeout(resolve, 100);
                    });
                }
                if (videoTrack && videoTrack.readyState !== 'live') {
                    videoTrack = undefined;
                }
                audioTrack = (_f = (_e = getLocalTrack(getTrackState(getState()), MEDIA_TYPE.AUDIO)) === null || _e === void 0 ? void 0 : _e.jitsiTrack) === null || _f === void 0 ? void 0 : _f.track;
                if (!audioTrack && !videoTrack) {
                    throw new Error('NoLocalStreams');
                }
                this.selfRecording.withVideo = Boolean(videoTrack);
                const localTracks = [];
                audioTrack && localTracks.push(audioTrack);
                videoTrack && localTracks.push(videoTrack);
                this.stream = new MediaStream(localTracks);
            }
            else {
                if (supportsCaptureHandle) {
                    // @ts-ignore
                    navigator.mediaDevices.setCaptureHandleConfig({
                        handle: `JitsiMeet-${tabId}`,
                        permittedOrigins: ['*']
                    });
                }
                // @ts-ignore
                gdmStream = yield navigator.mediaDevices.getDisplayMedia({
                    // @ts-ignore
                    preferCurrentTab: true,
                    video: true
                    // audio: true
                });
                // @ts-ignore
                const isBrowser = gdmStream.getVideoTracks()[0].getSettings().displaySurface === 'browser';
                if (!isBrowser || (supportsCaptureHandle // @ts-ignore
                    && ((_g = gdmStream.getVideoTracks()[0].getCaptureHandle()) === null || _g === void 0 ? void 0 : _g.handle) !== `JitsiMeet-${tabId}`)) {
                    gdmStream.getTracks().forEach((track) => track.stop());
                    throw new Error('WrongSurfaceSelected');
                }
                this.initializeAudioMixer();
                this.mixAudioStream(gdmStream);
                tracks.forEach((track) => {
                    var _a;
                    if (track.mediaType === MEDIA_TYPE.AUDIO) {
                        const audioTrack = (_a = track === null || track === void 0 ? void 0 : track.jitsiTrack) === null || _a === void 0 ? void 0 : _a.track;
                        this.addAudioTrackToLocalRecording(audioTrack);
                    }
                });
                this.stream = new MediaStream([
                    ...((_h = this.audioDestination) === null || _h === void 0 ? void 0 : _h.stream.getAudioTracks()) || [],
                    gdmStream.getVideoTracks()[0]
                ]);
            }
            this.recorder = new MediaRecorder(this.stream, {
                mimeType: this.mediaType,
                videoBitsPerSecond: VIDEO_BIT_RATE
            });
            this.recorder.addEventListener('dataavailable', e => {
                if (e.data && e.data.size > 0) {
                    this.testRecordingData.push(e.data);
                    this.totalTestSize -= e.data.size;
                    if (this.testRecordingData.length === 5) {
                        this.stopTestLocalRecording();
                    }
                }
            });
            this.recorder.addEventListener('error', event => {
                dispatch(showErrorNotification({
                    titleKey: 'Error occurred while recording',
                    custom: true,
                    //  @ts-ignore
                    description: event.error.name
                }));
            });
            if (!onlySelf) {
                this.recorder.addEventListener('stop', () => {
                    var _a;
                    (_a = this.stream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach((track) => track.stop());
                    gdmStream === null || gdmStream === void 0 ? void 0 : gdmStream.getTracks().forEach((track) => track.stop());
                });
                gdmStream === null || gdmStream === void 0 ? void 0 : gdmStream.addEventListener('inactive', () => {
                    dispatch(stopLocalVideoRecording());
                });
                this.stream.addEventListener('inactive', () => {
                    dispatch(stopLocalVideoRecording());
                });
            }
            this.recorder.start(1000);
            this.hasUploaded = false;
        });
    },
    /**
     * Whether or not we're currently recording locally.
     *
     * @returns {boolean}
     */
    isRecordingLocally() {
        return Boolean(this.recorder);
    }
};
export default LocalRecordingManager;
